<template>
    <button
        :id="id"
        ref="toggle"
        :class="['meatball-menu-button', show && 'open']"
        @click.stop="toggle"
    >
        <FontAwesomeIcon
            icon="ellipsis-h"
            size="lg"
            class="icon"
        />

        <b-popover
            ref="popover"
            :boundary-padding="0"
            custom-class="meatball-menu-popover"
            no-fade
            placement="bottomright"
            :show="show"
            :target="() => $refs.toggle"
            triggers="click blur"
            @hidden="close"
        >
            <!-- Menu items to be displayed in the popover; works best with `b-list-group` and `b-list-group-item`s -->
            <slot :close="close" />
        </b-popover>
    </button>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faEllipsisH} from '@fortawesome/pro-solid-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
    import uniqueId from 'lodash/uniqueId';

    library.add(faEllipsisH);

    /**
     * @group Buttons
     * A component to utilize a Kit Car Meatball Menu.
     */
    export default {
        name: 'MeatballMenu',
        components: {FontAwesomeIcon},
        props: {
            /**
             * Sets the 'id' attribute on the button
             */
            id: {
                type: String,
                // `() => uniqueId()`
                default: () => {
                    return uniqueId();
                },
            },
            /**
             * Sets the initial value of `show`, to show or
             * hide the menu
             */
            initialShow: {
                type: Boolean,
                required: false,
                // `false`
                default: false,
            },
        },
        data() {
            return {
                show: this.initialShow,
            };
        },
        methods: {
            close() {
                this.show = false;
                /**
                 * Emitted when the menu is closed
                 */
                this.$emit('closed');
            },
            toggle() {
                this.show = !this.show;
                /**
                 * Emitted when the button is clicked
                 * @arg `show`
                 */
                this.$emit('toggled', this.show);
            },
        },
    };
</script>
